// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-no-user {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.bloc-users .bloc-user {
  margin: 10px 0;
  padding: 15px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+kanban/components/dialog/see-affectation/see-affectation-kanban.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AAGI;EACI,cAAA;EACA,eAAA;AAAR","sourcesContent":[".text-no-user {\r\n    text-align: center;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.bloc-users {\r\n    .bloc-user {\r\n        margin: 10px 0;\r\n        padding: 15px 0;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
